import config from "@/config"
import http from "@/utils/request"

export default{
   
    map:{
		url: `${config.API_URL}/siteRegion`,
		name: "新增值班",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
    

}